/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, {
  useState, Fragment, useEffect, useRef,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Upload, Alert, notification, DatePicker, Checkbox, TimePicker,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { PlusOutlined, PlusCircleFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import Constants, { toISTDate } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import H3FormInput from '@Uilib/h3FormInput';
import RichTextEditor from '@Components/Common/RichTextEditor';
import RfqLines from './RfqLines';
import './style.scss';
import ErrorHandle from '../../../Common/ErrorHandle';
import rfqErrorList from './RfqErrors';

import DocConfigActions from '@Actions/docConfigActions';
import RestrictedAccessMessage from '../../../Common/RestrictedAccess/RestrictedAccessMessage';
import PRZSelect from '../../../Common/UI/PRZSelect';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';

const { Option } = Select;

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

const RfqForm = ({
  user, getRfqByIdLoading, match, createRfqLoading, updateRfqLoading, createRfq, updateRfq, getRfqById, history, selectedPurchaseRequest, getDocConfig, org, priceMasking,
}) => {
  const [isUserReady, setIsUserReady] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [rfqName, setRfqName] = useState('');
  const [vendorSelection, setVendorSelection] = useState('SINGLE_VENDOR');
  const [deliveryDate, setDeliveryDate] = useState(dayjs());
  const [isDDAtProductlevel, setIsDDAtProductlevel] = useState(true);
  const [isPriceWithTax, setIsPriceWithTax] = useState(false);
  const [quesData, setQuesData] = useState([]);
  const [data, setData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [publicFileList, setPublicFileList] = useState([]);
  // const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedRfq, setSelectedRfq] = useState();
  const [automaticallyMapVendor, setAutomaticallyMapVendor] = useState(false);
  const [docLevelError, setDocLevelError] = useState([]);
  const [lineLevelError, setLineLevelError] = useState([]);
  const [rfqNumber, setRfqNumber] = useState('');
  const [initialRfqNumber, setInitialRfqNumber] = useState('');
  const [docSeqId, setDocSeqId] = useState(null);

  useEffect(() => {
    if (selectedPurchaseRequest) {
      const dt = [];
      for (let j = 0; j < selectedPurchaseRequest?.purchase_requistion_lines?.length; j++) {
        const prLine = selectedPurchaseRequest?.purchase_requistion_lines?.[j];
        dt.push({
          key: uuidv4(),
          pr_line_id: prLine?.pr_line_id,
          delivery_tenant_id: selectedPurchaseRequest?.tenant_id,
          tenant_product_id: prLine?.tenant_product_id,
          product_type: prLine?.product_sku_info?.product_type,
          product_sku_id: prLine?.product_sku_info.product_sku_id,
          product_sku_info: prLine?.product_sku_info,
          product_sku_name: prLine?.product_sku_info.product_sku_name,
          quantity: prLine?.quantity,
          quotation_price: prLine?.target_price || 0,
          tax_info: prLine?.product_sku_info?.tax_info,
          productCategoryInfo: prLine?.product_sku_info?.product_category_info || {},
          tax_id: prLine?.product_sku_info?.tax_info?.tax_id,
          uom_id: prLine?.product_sku_info?.uom_id || 0,
          uom_info: prLine?.uom_info,
          uom_list: prLine?.product_sku_info?.uom_list,
          internal_sku_code: prLine?.product_sku_info?.internal_sku_code,
          ref_product_code: prLine?.ref_product_code,
          delivery_date: dayjs(),
          rfq_line_questions: [],
        });
      }
      setData(dt);
    } else if (!match.params.rfqId) {
      setData([
        {
          key: uuidv4(),
          product_sku_name: '',
          quantity: '',
          tax_id: '',
          tenantId: '',
          delivery_date: dayjs(),
          question: '',
          is_mandatory: false,
          rfq_line_questions: [],
        }]);
    } else {
      getRfqById(user?.tenant_info?.org_id, user?.tenant_info?.tenant_id, match.params.rfqId, (rfqData) => {
        setSelectedRfq(rfqData);
      });
      setIsUpdate(true);
    }
    getDocConfig(user?.tenant_info?.tenant_id, 'REQUEST_FOR_QUOTATION', (doc) => {
      const termsData = doc?.find((item) => item?.document_type === 'REQUEST_FOR_QUOTATION')?.allowed_fields?.find((field) => field?.field_name === 'default_t_and_c')?.field_value;
      if (termsData) {
        setTermsAndConditions(termsData);
      } else {
        setTermsAndConditions(selectedRfq?.terms_and_condition);
      }
    });
  }, []);
  useEffect(() => {
    if (isUpdate && selectedRfq?.rfq_id) {
      const rfqLinesData = selectedRfq?.rfq_lines?.map((rfqLine) => {
        const parentKey = uuidv4();
        return {
          ...rfqLine,
          key: parentKey,
          rfq_line_questions: rfqLine?.rfq_line_questions?.map((lineQues) => ({ ...lineQues, key: uuidv4(), parentKey })),
          uom_list: rfqLine?.product_sku_info?.uom_list,
          uom_info: rfqLine?.uom_info,
          delivery_date: dayjs(rfqLine?.delivery_date).add(5, 'hour').add(30, 'minute'),
          ref_product_code: rfqLine?.product_sku_info?.ref_product_code,
          productCategoryInfo: rfqLine?.product_sku_info?.product_category_info,
          internal_sku_code: rfqLine?.product_sku_info?.internal_sku_code,
          tax_info: rfqLine?.tax_group_info,
        };
      });

      setData(rfqLinesData);
      setRfqName(selectedRfq?.description);
      setVendorSelection(selectedRfq?.selection);
      setDeliveryDate(dayjs(selectedRfq?.delivery_date).add(5, 'hour').add(30, 'minute'));
      setIsDDAtProductlevel(selectedRfq?.is_delivery_date_at_product_level);
      setAutomaticallyMapVendor(selectedRfq?.add_sku_vendors);
      setIsPriceWithTax(selectedRfq?.price_with_tax);
      setQuesData(selectedRfq?.rfq_questions?.map((item) => ({ ...item, quesKey: uuidv4() })));
      // setStartTime(dayjs(selectedRfq?.begin_time));
      setEndTime(dayjs(selectedRfq?.end_time));
      setTermsAndConditions(selectedRfq?.terms_and_condition);
      setFileList(selectedRfq?.attachments);
      setPublicFileList(selectedRfq?.public_attachments);
      setRfqNumber(selectedRfq?.rfq_number);
    }
  }, [isUpdate, selectedRfq]);

  useEffect(() => {
    const errors = rfqErrorList({rfqName, endTime, data, rfqNumber});
    setDocLevelError(errors.docLevelError);
    setLineLevelError(errors.lineLevelError); 
  }, [docLevelError, lineLevelError] 
)

  const addNewQuesRow = () => {
    const copyQuesData = JSON.parse(JSON.stringify(quesData));
    copyQuesData.push({
      quesKey: uuidv4(),
      question: '',
      is_mandatory: false,
    });
    setQuesData(copyQuesData);
  };

  const addNewRow = () => {
    const copyData = JSON.parse(JSON.stringify(data));
    const parentKey = uuidv4();
    copyData.push({
      key: parentKey,
      product_sku_name: '',
      quantity: '',
      quotationPrice: '',
      tax_id: '',
      tenantId: '',
      delivery_date: dayjs(),
      question: '',
      is_mandatory: false,
      rfq_line_questions: [{
        key: uuidv4(), parentKey, question: '', is_mandatory: false,
      }],
    });
    setData(copyData);
  };

  const handleDeleteQues = (quesKey) => {
    const copyQuesData = quesData.filter(
      (item) => item?.quesKey !== quesKey,
    );
    setQuesData(copyQuesData);
  };

  const handleDelete = (key) => {
    if (data?.length === 1) {
      const parentKey = uuidv4();
      setData([
        {
          key: parentKey,
          product_name: '',
          quantity: '',
          quotation_price: '',
          tax_id: '',
          discount: 0,
          delivery_date: dayjs(),
          question: '',
          is_mandatory: false,
          rfq_line_questions: [{
            key: uuidv4(), parentKey, question: '', is_mandatory: false,
          }],
        },
      ]);
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
    }
  };

  const addNewLineQuesRow = (key) => {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      const lineQues = copyData[i]?.rfq_line_questions;
      if (copyData[i]?.key === key) {
        lineQues.push({
          key: uuidv4(), parentKey: key, question: '', is_mandatory: false,
        });
      }
    }
    setData(copyData);
  };

  const deleteLineQuesRow = (parentKey, key) => {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      const lineQues = copyData[i]?.rfq_line_questions;
      if (copyData[i]?.key === parentKey) {
        const copyLineQues = lineQues.filter((item) => item.key !== key);
        copyData[i].rfq_line_questions = copyLineQues;
      }
      setData(copyData);
    }
  };

  const handleProductChange = (tenantSku, key, productData) => {
    const copyData = JSON.parse(JSON.stringify(data));
    const autoPrintDescription = user?.tenant_info?.global_config?.settings?.print_description_automatically;
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i].key === key) {
        const copyDataItem = copyData[i];
        copyDataItem.tenant_product_id = tenantSku?.tenant_product_id;
        copyDataItem.product_type = tenantSku?.product_type;
        copyDataItem.product_sku_id = tenantSku?.product_info.product_sku_id;
        copyDataItem.product_sku_info = tenantSku?.product_info;
        copyDataItem.product_sku_name = tenantSku?.product_info.product_sku_name;
        copyDataItem.quantity = '1';
        copyDataItem.quotation_price = tenantSku?.cost_price || 0;
        copyDataItem.tax_info = {
          tax_id: tenantSku?.product_info?.tax_id,
          tax_name: tenantSku?.product_info?.tax_name,
          tax_value: tenantSku?.product_info?.tax_value,
        };
        copyDataItem.tax_id = tenantSku?.product_info?.tax_id;
        copyDataItem.uom_id = tenantSku?.product_info?.uom_id || 0;
        copyDataItem.uom_info = tenantSku?.uom_info;
        copyDataItem.uom_list = tenantSku?.uom_list;
        copyDataItem.uomGroup = tenantSku?.group_id;
        copyDataItem.productCategoryInfo = tenantSku?.product_category_info || {};
        copyDataItem.internal_sku_code = tenantSku?.internal_sku_code;
        copyDataItem.ref_product_code = tenantSku?.ref_product_code;
        copyDataItem.delivery_date = dayjs();
        copyDataItem.remark = autoPrintDescription ? (productData?.description || '')?.replace(/<[^>]+>/g, '') : '';
        copyData[i] = copyDataItem;
      }
    }
    setData(copyData);
  };

  const handleProductChangeValue = (value, key) => {
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      if (copyData[i].key === key) {
        const copyDataItem = copyData[i];
        copyDataItem.product_sku_name = value;
        copyData[i] = copyDataItem;
      }
    }
    setData(copyData);
  };

  const isDateValid = () => {
    let isValid = true;
    for (let i = 0; i < data?.length; i++) {
      if (!data[i]?.product_sku_name || !data[i]?.quantity || !data[i]?.uom_id || !data[i]?.tax_id || !data[i]?.delivery_tenant_id || (isDDAtProductlevel && !data[i]?.delivery_date)) {
        isValid = false;
      }
      if (data[i]?.rfq_line_questions?.length) {
        for (let j = 0; j < data[i]?.rfq_line_questions?.length; j++) {
          if (!data[i]?.rfq_line_questions[j]?.question) {
            isValid = false;
          }
        }
      }
    }
    if (docLevelError?.length > 0 || lineLevelError?.length > 0) {
      return isValid = false;
    }
    return isValid;
  };

  const isQuesDateValid = () => {
    let isValid = true;
    for (let i = 0; i < quesData?.length; i++) {
      if (!quesData[i]?.question) {
        isValid = false;
      }
    }
    return isValid;
  };

  const handleRFQ = () => {
    setFormSubmitted(true);
    if (rfqName && endTime && isDateValid() && isQuesDateValid()) {
      const rfqLinesData = data?.map((item) => ({
        pr_line_id: selectedPurchaseRequest ? item?.pr_line_id : undefined,
        rfq_id: selectedRfq ? item?.rfq_id : undefined,
        rfq_line_id: selectedRfq ? item?.rfq_line_id : undefined,
        product_sku_id: item?.product_sku_id,
        product_sku_name: item?.product_sku_name,
        tenant_id: user?.tenant_info?.tenant_id,
        delivery_tenant_id: item?.delivery_tenant_id,
        quantity: item?.quantity,
        uom_id: item?.uom_id,
        uom_info: item?.uom_info,
        tax_id: item?.tax_id,
        tax_group_info: item?.tax_info,
        remark: item?.remark,
        delivery_date: isDDAtProductlevel ? item?.delivery_date : null,
        quotation_price: item?.quotation_price,
        rfq_line_questions: item?.rfq_line_questions?.map((item) => ({ ...item, question: item?.question, is_mandatory: item?.is_mandatory })),
      }));

      const payload = {
        purchase_requisition_id: selectedPurchaseRequest?.purchase_requisition_id || null,
        org_id: user?.tenant_info?.org_id,
        tenant_id: user?.tenant_info?.tenant_id,
        rfq_id: selectedRfq ? selectedRfq?.rfq_id : undefined,
        description: rfqName,
        // begin_time: dayjs(startTime).valueOf(),
        end_time: dayjs(endTime).valueOf(),
        selection: vendorSelection,
        is_delivery_date_at_product_level: isDDAtProductlevel,
        add_sku_vendors: automaticallyMapVendor || false,
        delivery_date: deliveryDate,
        price_with_tax: isPriceWithTax,
        terms_and_condition: termsAndConditions,
        status: 'DRAFT',
        attachments: fileList?.map((attachment) => ({
          url:
            attachment?.response?.response?.location || attachment?.url,
          type: attachment.type,
          name: attachment.name,
          uid: attachment.uid,
        })) || [],
        public_attachments: publicFileList?.map((attachment) => ({
          url:
            attachment?.response?.response?.location || attachment?.url,
          type: attachment.type,
          name: attachment.name,
          uid: attachment.uid,
        })) || [],
        rfq_questions: quesData,
        rfq_lines: rfqLinesData,
        rfq_number: initialRfqNumber?.toLowerCase()?.trim() === rfqNumber?.toLowerCase()?.trim() ? null : rfqNumber,
        seq_id: docSeqId || null,
      };
      if (match.params.rfqId) {
        updateRfq(payload, () => {
          history.push(`/purchase/rfq/view/${selectedRfq?.rfq_id}`);
        });
      } else {
        createRfq(payload, (rfq) => {
          history.push(`/purchase/rfq/view/${rfq?.rfq_id}`);
        });
      }
    }
  };

  // const currentHour = dayjs().hour();
  // const currentMinute = dayjs().minute();
  const currentDate = dayjs();
  const currentHour = currentDate.hour();
  const currentMinute = currentDate.minute();

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const vendorOptions = [
    {
      value: 'SINGLE_VENDOR',
      label: 'Entire Order to Single Vendor',
    },
    {
      value: 'MULTIPLE_VENDOR',
      label: 'Different Items to Different Vendors',
    },
  ];

  return (
    <Fragment>
      <div className="rfq-form" style={{ paddingTop: selectedPurchaseRequest ? '0px' : '90px' }}>
        {getRfqByIdLoading ? (
          <div className="rfq-form__loading__wrapper">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <div
                key={item}
                className="rfq-form__loading__wrapper-row"
              >
                <div className="rfq-form__loading__wrapper-row__label loadingBlock" />
                <div className="rfq-form__loading__wrapper-row__value loadingBlock" />
              </div>
            ))}
            <div className="rfq-form__loading__wrapper-table loadingBlock" />
            <div className="rfq-form__loading__wrapper-details loadingBlock" />
          </div>
        ) : (
          <div className="rfq-form__wrapper">
            {(formSubmitted && (docLevelError?.length>0 || lineLevelError?.length>0)) && (
                  <ErrorHandle message='Mandatory fields required' docLevelErrors={docLevelError} lineLevelErrors={lineLevelError} />
                )}

            <div className="ant-row">

              <DocumentNumberSeqInput
                valueFromProps={rfqNumber}
                setInitialDocSeqNumber={(value) => setInitialRfqNumber(value)}
                updateCase={match?.params?.rfqId}
                entityName="REQUEST_FOR_QUOTATION"
                docSeqId={docSeqId}
                tenantId={user?.tenant_info?.tenant_id}
                onChangeFromProps={(event, newValue, seqId) => {
                  setRfqNumber(newValue ? (newValue || '') : (event?.target?.value || ''));
                  setDocSeqId(seqId);
                }}
                docTitle="RFQ#"
                formSubmitted={formSubmitted}
                rowClassName="ant-col-md-12"
                inputRowClassName="rfq-form__input-row"
                labelClassName="rfq-form__input-row__label"
                containerClassName="orgInputContainer"
                inputWrapperClassName="rfq-form__input-row__input"
                seqClassName="seq-selector"
                selectorStyle={{
                  opacity: 0,
                  backgroundColor: 'transparent',
                  zIndex: 1,
                  top: '-24px',
                  width: '20%',
                  right: '0',
                }}
                s
              />

              <div className="ant-col-md-12" />

              <div className="ant-col-md-12">
                <div className="rfq-form__input-row">
                  <H3Text
                    required
                    text="RFQ Name"
                    className="rfq-form__input-row__label"
                  />
                  <H3FormInput
                    name="a valid RFQ name"
                    type="text"
                    containerClassName="orgInputContainer rfq-form__input-row__input"
                    labelClassName="orgFormLabel"
                    inputClassName="orgFormInput input"
                    placeholder=""
                    onChange={(e) => setRfqName(e.target.value)}
                    value={rfqName}
                    showError={formSubmitted && !rfqName}
                    disabled={createRfqLoading || updateRfqLoading}
                  />
                </div>
              </div>
              <div className="ant-col-md-12" />

              <div className="ant-col-md-12">
                <div className="rfq-form__input-row">
                  <H3Text
                    text="Vendor Selection"
                    className="rfq-form__input-row__label"
                    required
                  />
                  <div className="rfq-form__input-row__input orgInputContainer">
                    <PRZSelect
                      value={vendorSelection}
                      onChange={(value) => {
                        setVendorSelection(value);
                      }}
                      className="input"
                      options={vendorOptions}
                    />
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />

              {/* <div className="ant-col-md-12">
                <div className="rfq-form__input-row">
                  <H3Text
                    required
                    text="Start Time"
                    className="rfq-form__input-row__label"
                  />
                  <div className="rfq-form__input-row__input orgInputContainer">
                    <DatePicker
                      value={startTime}
                      onChange={(value) => {
                        setStartTime(value);
                      }}
                      format="YYYY-MM-DD hh:mm A"
                      disabledDate={createRfqLoading || updateRfqLoading}
                      disabledTime={createRfqLoading || updateRfqLoading}
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                      style={{
                        border: '1px solid rgba(68, 130, 218, 0.2)',
                        borderRadius: '2px',
                        height: '32px',
                        padding: '1px 10px',
                        width: '100%',
                        background: 'white',
                      }}
                    />
                    {formSubmitted && !startTime && (
                      <div className="input-error">
                        *Please enter start time
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" /> */}

              <div className="ant-col-md-12">
                <div className="rfq-form__input-row">
                  <H3Text
                    required
                    text="Deadline"
                    className="rfq-form__input-row__label"
                  />
                  <div className="rfq-form__input-row__input orgInputContainer">
                    <DatePicker
                      value={endTime}
                      onChange={(value) => {
                        setEndTime(value);
                      }}
                      format="YYYY-MM-DD h:mm A"
                      disabledDate={(current) => current && current < currentDate.startOf('day')}
                      disabledTime={(current) => {
                        const isSameDay = current && current.isSame(currentDate, 'day');
                        if (isSameDay) {
                          return {
                            disabledHours: () => Array.from({ length: currentHour }, (_, index) => index),
                            disabledMinutes: (selectedHour) => (selectedHour === currentHour ? Array.from({ length: currentMinute }, (_, index) => index) : []),
                            disabledMeridiem: () => (currentHour < 12 ? ['PM'] : ['AM', 'PM']),
                          };
                        }
                        return {};
                      }}
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                        hideDisabledOptions: false,
                      }}
                      style={{
                        border: '1px solid rgba(68, 130, 218, 0.2)',
                        borderRadius: '2px',
                        height: '28px',
                        padding: '1px 10px',
                        width: '100%',
                        background: 'white',
                      }}
                    />
                    {formSubmitted && !endTime && (
                      <div className="input-error">
                        *Please enter end time
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />
              {/* <div className="ant-col-md-12"> */}
              {/*  <div className="rfq-form__input-row" style={{ marginBottom: '10px' }}> */}
              {/*    <H3Text */}
              {/*      text="" */}
              {/*      className="rfq-form__input-row__label" */}
              {/*    /> */}
              {/*    <div className="rfq-form__input-row__input"> */}
              {/*      <div> */}
              {/*        <Checkbox */}
              {/*          disabled={createRfqLoading || updateRfqLoading} */}
              {/*          checked={isPriceWithTax} */}
              {/*          onChange={() => { */}
              {/*            setIsPriceWithTax(!isPriceWithTax); */}
              {/*          }} */}
              {/*        /> */}
              {/*        <span */}
              {/*          style={{ */}
              {/*            fontWeight: '400', */}
              {/*            fontSize: '12px', */}
              {/*            marginLeft: '5px', */}
              {/*          }} */}
              {/*        > */}
              {/*          Submission of prices is with taxes */}
              {/*        </span> */}
              {/*      </div> */}
              {/*    </div> */}
              {/*  </div> */}
              {/* </div> */}
              {/* <div className="ant-col-md-12" /> */}
              <div className="ant-col-md-12">
                <div className="rfq-form__input-row" style={{ marginBottom: '10px' }}>
                  <H3Text
                    text=""
                    className="rfq-form__input-row__label"
                  />
                  <div className="rfq-form__input-row__input">
                    <div>
                      <Checkbox
                        disabled={createRfqLoading || updateRfqLoading}
                        checked={isDDAtProductlevel}
                        onChange={() => {
                          setIsDDAtProductlevel(!isDDAtProductlevel);
                        }}
                      />
                      <span
                        style={{
                          fontWeight: '400',
                          fontSize: '12px',
                          marginLeft: '5px',
                        }}
                      >
                        All items have different delivery date
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />

              {!isDDAtProductlevel && (
                <Fragment>
                  <div className="ant-col-md-12">
                    <div className="rfq-form__input-row">
                      <H3Text
                        required={!isDDAtProductlevel}
                        text="Delivery Date"
                        className="rfq-form__input-row__label"
                      />
                      <div className="rfq-form__input-row__input orgInputContainer">
                        {deliveryDate && (
                          <Fragment>
                            <DatePicker
                              value={deliveryDate}
                              disabledDate={(current) => current && current < dayjs().startOf('day')}
                              onChange={(value) => {
                                setDeliveryDate(value);
                              }}
                              format="DD-MM-YYYY"
                              style={{
                                border: '1px solid rgba(68, 130, 218, 0.2)',
                                borderRadius: '2px',
                                height: '32px',
                                padding: '1px 10px',
                                width: '100%',
                                background: 'white',
                              }}
                              disabled={createRfqLoading || updateRfqLoading}
                            />
                            {formSubmitted && !isDDAtProductlevel && !deliveryDate && (
                              <div className="input-error">
                                *Please enter delivery date
                              </div>
                            )}
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-12" />
                </Fragment>
              )}
              <div className="ant-col-md-12">
                <div className="rfq-form__input-row" style={{ marginBottom: '10px' }}>
                  <H3Text
                    text=""
                    className="rfq-form__input-row__label"
                  />
                  <div className="rfq-form__input-row__input">
                    <div>
                      <Checkbox
                        disabled={createRfqLoading || updateRfqLoading || selectedRfq?.rfq_id}
                        checked={automaticallyMapVendor}
                        onChange={() => {
                          setAutomaticallyMapVendor(!automaticallyMapVendor);
                        }}
                      />
                      <span
                        style={{
                          fontWeight: '400',
                          fontSize: '12px',
                          marginLeft: '5px',
                        }}
                      >
                        Automatically invite vendors mapped to selected products
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-12" />
              <div className="ant-col-md-12">
                <div className="rfq-form__ques-wrapper">
                  <H3Text
                    text="Questions?"
                    className="rfq-form__ques-label"
                  />
                  <div className="rfq-form__ques-input-wrapper">
                    <div className="ant-row">
                      <div className="ant-col-md-24">
                        {quesData?.map((ques) => (
                          <div
                            style={{ display: 'flex', alignItems: 'baseline' }}
                            key={ques?.quesKey}
                            className="rfq-form__ques-input-row__input-wrapper"
                          >
                            <H3FormInput
                              type="text"
                              containerClassName="orgInputContainer rfq-form__ques-input-row__input"
                              labelClassName="orgFormLabel"
                              inputClassName={`orgFormInput input ${(formSubmitted && !ques?.question) ? 'orgFormError' : ''}`}
                              placeholder=""
                              onChange={(e) => {
                                const copyQuesData = JSON.parse(
                                  JSON.stringify(quesData),
                                );
                                copyQuesData.map((item) => {
                                  if (item.quesKey === ques.quesKey) {
                                    item.question = e.target.value;
                                  }
                                  return quesData;
                                });
                                setQuesData(copyQuesData);
                              }}
                              value={ques?.question}
                              disabled={createRfqLoading || updateRfqLoading}
                            />
                            <div className="rfq-form__ques-input-row__input-checkbox">
                              <Checkbox
                                disabled={createRfqLoading || updateRfqLoading}
                                checked={ques?.is_mandatory}
                                onChange={(e) => {
                                  const copyQuesData = JSON.parse(
                                    JSON.stringify(quesData),
                                  );
                                  copyQuesData.map((item) => {
                                    if (item.quesKey === ques.quesKey) {
                                      item.is_mandatory = e.target.checked;
                                    }
                                    return quesData;
                                  });
                                  setQuesData(copyQuesData);
                                }}
                              >
                                required

                              </Checkbox>
                              <div
                                className="rfq-form__ques-remove"
                                onClick={() => handleDeleteQues(ques?.quesKey)}
                              >
                                <FontAwesomeIcon
                                  icon={faCircleXmark}
                                  size="sm"
                                  style={{ color: '#6f7276' }}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                        {quesData?.length < 5 && (
                          <div className="ant-row">
                            <div className="ant-col-md-12">
                              <div
                                className="new-charge-row-button"
                                onClick={() => addNewQuesRow()}
                              >
                                <span className="new-charge-row-button__icon">
                                  <PlusCircleFilled />
                                </span>
                                <div>Add Question</div>
                              </div>
                            </div>
                            <div className="ant-col-md-12" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ant-col-md-8" />
            </div>
            <RfqLines
              title={() => (
                <div className="so-lines-title__wrapper">
                  <H3Text
                    text={`RFQ Products(${data.filter(
                      (item) => item.product_sku_name?.length > 0,
                    )?.length
                      })`}
                    className="create-po__input-row__label"
                  />
                </div>
              )}
              isDDAtProductlevel={isDDAtProductlevel}
              handleDelete={handleDelete}
              handleProductChange={handleProductChange}
              handleProductChangeValue={handleProductChangeValue}
              data={data}
              addNewRow={() => addNewRow()}
              addNewLineQuesRow={(parentKey) => addNewLineQuesRow(parentKey)}
              deleteLineQuesRow={deleteLineQuesRow}
              updateData={(updatedData) => setData(updatedData)}
              formSubmitted={formSubmitted}
              loading={createRfqLoading || updateRfqLoading}
            />
            <div
              className="new-row-button"
              onClick={() => addNewRow()}
            >
              <span className="new-row-button__icon">
                <PlusCircleFilled />
              </span>
              <div>New Item</div>
            </div>

            <div className="text-area__po-container" style={{ width: '50%', marginTop: '20px' }}>
              <label className="orgFormLabel">Terms and Conditions</label>
              <RichTextEditor
                onChange={(value) => setTermsAndConditions(value)}
                value={termsAndConditions}
                disabled={createRfqLoading || updateRfqLoading}
                placeholder="Enter terms and conditions here.."
              />
            </div>

            <div style={{ display: 'flex', marginTop: '20px' }}>
              <div
                className="text-area__po-container"
                style={{ marginRight: '15px' }}
              >
                <label className="orgFormLabel">Internal Attachment(s)</label>
                <Upload
                  action={Constants.UPLOAD_FILE}
                  listType="picture-card"
                  fileList={fileList}
                  disabled={createRfqLoading || updateRfqLoading}
                  onChange={(fileListData) => {
                    setFileList(fileListData?.fileList?.map((item) => ({
                      ...item,
                      url: item?.response?.response?.location || item?.url,
                    })));
                  }}
                >
                  {fileList?.length >= 20 ? null : uploadButton}
                </Upload>
              </div>

              <div
                className="text-area__po-container"
              >
                <label className="orgFormLabel">Public Attachment(s)</label>
                <Upload
                  action={Constants.UPLOAD_FILE}
                  listType="picture-card"
                  fileList={publicFileList}
                  disabled={createRfqLoading || updateRfqLoading}
                  onChange={(fileListData) => {
                    setPublicFileList(fileListData?.fileList?.map((item) => ({
                      ...item,
                      url: item?.response?.response?.location || item?.url,
                    })));
                  }}
                >
                  {publicFileList?.length >= 3 ? null : uploadButton}
                </Upload>
              </div>
            </div>

            <div className="rfq-form__footer">
              <H3Button
                text={selectedRfq ? 'Update RFQ' : 'Create RFQ'}
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                customClass="rfq-form__footer-draft rfq-form__footer-submit"
                onClick={() => {
                  if (!createRfqLoading) {
                    handleRFQ();
                  }
                }}
                isLoading={createRfqLoading || updateRfqLoading}
                disabled={createRfqLoading || updateRfqLoading}
              />

              {(isDataMaskingPolicyEnable && isHideCostPrice) && <RestrictedAccessMessage message={"You don't have access to view & edit target price"} />}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers,
}) => ({
  user: UserReducers.user,
  createRfqLoading: RfqReducers.createRfqLoading,
  updateRfqLoading: RfqReducers.updateRfqLoading,
  getRfqByIdLoading: RfqReducers.getRfqByIdLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  createRfq: (payload, callback) => dispatch(RfqActions.createRfq(payload, callback)),
  updateRfq: (payload, callback) => dispatch(RfqActions.updateRfq(payload, callback)),
  getRfqResults: (payload, callback) => dispatch(RfqActions.getRfqResults(payload, callback)),
  getRfqById: (orgId, tenantId, rfqId, callback) => dispatch(RfqActions.getRfqById(orgId, tenantId, rfqId, callback)),
  getRfqByIdSuccess: (selectedRfq) => dispatch(RfqActions.getRfqByIdSuccess(selectedRfq)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

RfqForm.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  match: PropTypes.any,
  selectedPurchaseRequest: PropTypes.any,
  createRfq: PropTypes.func,
  updateRfq: PropTypes.func,
  createRfqLoading: PropTypes.bool,
  updateRfqLoading: PropTypes.bool,
  getRfqById: PropTypes.func,
  getRfqByIdLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RfqForm));
